import { useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import ChatWidget from "@/components/ChatWidget";

export default function WidgetDemo() {
  const { salonId: paramSalonId } = useParams();
  const [searchParams] = useSearchParams();
  
  // Support both URL param (/widget-demo/:salonId) and query param (?salon_id=xxx)
  const salonId = paramSalonId || searchParams.get('salon_id');
  const isEmbed = searchParams.get('embed') === 'true';
  
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      if (!salonId) {
        console.error("Widget Demo: No salon ID provided");
        return;
      }
      
      try {
        const response = await axios.get(`${API}/widget/${salonId}/config`);
        setConfig(response.data);
      } catch (error) {
        console.error("Error fetching widget config:", error);
      }
    };

    fetchConfig();
    
    // Hide Emergent badge completely
    const badge = document.getElementById('emergent-badge');
    if (badge) {
      badge.style.display = 'none';
    }
    
    // If embedded, make background transparent
    if (isEmbed) {
      document.body.style.background = 'transparent';
    }
  }, [salonId, isEmbed]);

  if (!config) {
    return <div className="min-h-screen bg-transparent" />;
  }

  return (
    <>
      <ChatWidget salonId={salonId} config={config} />
    </>
  );
}